import React from "react";

import { useTranslation } from "react-i18next";

import { ButtonGroup } from "@caelor/ui";
import ColorPicker from "../../../../../../../components/ui/color-picker/ColorPicker";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
  SettingsOptionHeading,
} from "../../../styles";
import { ALIGNMENT_OPTIONS } from "./options";
import { useAdvancedTabsGroupStore } from "../../../../../../../stores/use-advanced-tabs-group-store";
import { ADVANCED_TABS_GROUP_PROP } from "./defaults";

const AdvancedTabsGroupSettings = () => {
  const { t } = useTranslation();

  const { data, setData } = useAdvancedTabsGroupStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));

  return (
    <>
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("alignment")}</SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel>{t("align")}</OptionLabel>
          <OptionContent>
            <ButtonGroup
              items={ALIGNMENT_OPTIONS}
              value={data[ADVANCED_TABS_GROUP_PROP.ALIGNMENT]}
              onClick={(value) =>
                setData({ [ADVANCED_TABS_GROUP_PROP.ALIGNMENT]: value })
              }
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("styling-options")}</SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel alignToTop>{t("colors")}</OptionLabel>
          <OptionContent>
            <ColorPicker
              value={data[ADVANCED_TABS_GROUP_PROP.COLORS]}
              onChange={(value) =>
                setData({ [ADVANCED_TABS_GROUP_PROP.COLORS]: value })
              }
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
    </>
  );
};

export default AdvancedTabsGroupSettings;
